<template>
  <!-- ▼Main Container -->
  <div class="boss-main-container">
    <div class="boss-main-wrap boss-main-content-wrap">
      <setting-header title="一次面接候補日設定" />
      <p class="boss-text margin-top-0 margin-bottom-1">
        応募時に、一次面接の希望日をヒアリングする機能です。<br>
        任意項目のため回答のない場合や、外部提携サイト経由の応募は機能が反映されない場合があります。
      </p>

      <!-- 一次面接利用設定 -->
      <form-label
        label="一次面接候補日設定機能"
        class-name="boss-text margin-top-0"
        is-required
      >
        <template #body>
          <div class="pega-relative height-100">
            <div
              v-for="(whetherToUse, i) in whetherToUses"
              :key="i"
            >
              <label class="pega-badge-radio pega-mr-5">
                <input
                  :value="whetherToUse.value"
                  :checked="isUseSetting === whetherToUse.value"
                  type="radio"
                  :data-test="`use-setting-radio${i}`"
                  @click="updateIsUseSetting(whetherToUse.value)"
                >
                <span
                  class="pega-badge-radio-text pega-badge-radio-check-mark"
                  :data-test="`use-setting-label${i}`"
                >{{ whetherToUse.label }}</span>
              </label>
            </div>
            <div class="pega-annotation-text-padding width-100">
              <a
                :href="`/help/guide/index_274.html`"
                data-test="use-setting-about-link"
                target="_blank"
              >
                一次面接候補日設定機能とは？
              </a>
            </div>
          </div>
        </template>
      </form-label>
      <!-- 一次面接利用設定 ここまで -->

      <div
        v-if="isUseSetting"
        data-test="schedule-list"
      >
        <!-- 求人表示 -->
        <div
          class="boss-joboffer-title boss-setting margin-top-1"
          data-test="candidate-date-title"
        >
          求人設定
        </div>
        <p
          class="boss-text margin-top-0 margin-bottom-1"
          data-test="description"
        >
          求人ごとに表示させるカレンダーを設定できます。<br>
          ※掲載中、あるいは今後掲載予定の求人が表示されます。通常、掲載開始日の前日15時以降から設定可能です。
        </p>
        <interview-candidate-date-jobs
          :jobs="jobs"
          :schedules="schedules"
          @update="updateJobScheduleLinking"
        />
        <!-- 求人表示 ここまで -->

        <!-- カレンダー表示 -->
        <div class="boss-joboffer-title boss-setting margin-top-1">
          応募者への表示日程
        </div>
        <p class="boss-text margin-top-0 margin-bottom-1">
          応募者へ現在表示されている日程を確認できます。「編集する」から設定できます。
        </p>
        <interview-candidate-date-schedules
          class="boss-text margin-top-0"
          :schedules="schedules"
          :jobs="jobs"
        />
      <!-- カレンダー表示 ここまで -->
      </div>
    </div>
  </div>
  <!-- ▲Main Container -->
</template>

<script>
import SettingHeader from '@/components/atoms/SettingHeader'
import InterviewCandidateDateJobs from '@/components/organisms/InterviewCandidateDateJobs'
import InterviewCandidateDateSchedules from '@/components/organisms/InterviewCandidateDateSchedules'
import FormLabel from '@/components/atoms/FormLabel'

export default {
  components: {
    SettingHeader,
    InterviewCandidateDateJobs,
    InterviewCandidateDateSchedules,
    FormLabel
  },
  data () {
    return {
      interviewCandidates: [],
      whetherToUses: [
        {
          value: true,
          label: '利用する'
        },
        {
          value: false,
          label: '利用しない'
        }
      ],
      isUseSetting: undefined,
      jobs: [],
      schedules: []
    }
  },
  created () {
    this.fetchIsUseSetting()
    this.fetchJobs()
    this.fetchSchedules()
  },
  methods: {
    fetchJobs () {
      this.$http.secured.get('/interview_candidate_date/jobs').then(response => {
        this.$set(this, 'jobs', response.data)
      })
    },
    fetchSchedules () {
      this.$http.secured.get('/interview_candidate_date/schedules').then(response => {
        this.$set(this, 'schedules', response.data)
      })
    },
    fetchIsUseSetting () {
      this.$http.secured.get('/interview_candidate_date/setting/is_active').then(response => {
        this.$set(this, 'isUseSetting', response.data)
      })
    },
    updateIsUseSetting (value) {
      this.$set(this, 'isUseSetting', value)
      this.$http.secured.put('/interview_candidate_date/setting/is_active', { isActive: this.isUseSetting }).then(() => {
        if (this.isUseSetting) {
          this.$toasted.global.success({ message: '利用するに設定しました。' })
        } else {
          this.$toasted.global.success({ message: '利用しないに設定しました。' })
        }
      })
    },
    updateJobScheduleLinking (jobId, scheduleId) {
      this.$set(this.jobs[this.jobs.findIndex(job => job.id === jobId)], 'scheduleId', scheduleId)
    }
  }
}
</script>
